import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  DA_DIREKT_REFERRAL_PAGE_LINK_NAV_DENTAL,
  DA_DIREKT_REFERRAL_PAGE_LINK_NAV_PET,
  DENTOLO_HELP_LINK,
  INSURANCE_TYPE_DENTOLO,
  INSURANCE_TYPE_PETOLO,
  INSURANCE_TYPE_VITOLO,
  PETOLO_HELP_LINK,
  VITOLO_HELP_LINK,
} from '../../shared';

import IconExternalLink from '../../components/Icons/IconExternalLink';

const dentoloHelpLinkItems = (intl) => [
  {
    text: intl.formatMessage({ id: 'menu.header.item.help_center' }),
    link: DENTOLO_HELP_LINK,
    externalUrl: true,
    icon: '/images/navbar/help_center.svg',
  },
  {
    text: intl.formatMessage({ id: 'menu.header.item.contacts' }),
    link: '/contact',
    externalUrl: false,
    icon: '/images/navbar/contact.svg',
  },
];

const petoloHelpLinkItems = (intl) => [
  {
    text: intl.formatMessage({ id: 'menu.header.item.help_center' }),
    link: PETOLO_HELP_LINK,
    externalUrl: true,
    icon: '/images/navbar/help_center.svg',
  },
  {
    text: intl.formatMessage({ id: 'menu.header.item.contacts' }),
    link: '/contact',
    externalUrl: false,
    icon: '/images/navbar/contact.svg',
  },
];

const patoloHelpLinkItems = (intl) => [
  {
    text: intl.formatMessage({ id: 'menu.header.item.contacts' }),
    link: '/contact',
    externalUrl: false,
    icon: '/images/navbar/contact.svg',
  },
];

const vitoloHelpLinkItems = (intl) => [
  {
    text: intl.formatMessage({ id: 'menu.header.item.help_center' }),
    link: VITOLO_HELP_LINK,
    externalUrl: true,
    icon: '/images/navbar/help_center.svg',
  },
  {
    text: intl.formatMessage({ id: 'menu.header.item.contacts' }),
    link: '/contact',
    externalUrl: false,
    icon: '/images/navbar/contact.svg',
  },
];

export const helpLinkItems = (intl, insuraceType, isPatolo) => {
  switch (insuraceType) {
    case INSURANCE_TYPE_DENTOLO:
      return dentoloHelpLinkItems(intl);
    case INSURANCE_TYPE_PETOLO:
      return isPatolo ? patoloHelpLinkItems(intl) : petoloHelpLinkItems(intl);
    case INSURANCE_TYPE_VITOLO:
      return vitoloHelpLinkItems(intl);
    default:
      return [];
  }
};

export const myProfileLinkItems = (intl) => [
  {
    text: intl.formatMessage({ id: 'menu.header.item.dashboard' }),
    link: '/dashboard',
    externalUrl: false,
    icon: '/images/navbar/dashboard.svg',
  },
  {
    text: intl.formatMessage({ id: 'menu.header.item.tarif' }),
    link: '/policy-info',
    externalUrl: false,
    icon: '/images/navbar/tarifdetails.svg',
  },
  {
    text: intl.formatMessage({ id: 'menu.header.item.contact_details' }),
    link: '/user-info',
    externalUrl: false,
    icon: '/images/navbar/contract_management.svg',
  },
  {
    text: intl.formatMessage({ id: 'menu.header.item.docs' }),
    link: '/contract-docs',
    externalUrl: false,
    icon: '/images/navbar/contract_documents.svg',
  },
  {
    text: intl.formatMessage({ id: 'menu.header.item.premiums' }),
    link: '/payment-details',
    externalUrl: false,
    icon: '/images/navbar/insurance_premiums.svg',
  },
  {
    text: intl.formatMessage({ id: 'menu.header.item.contribution_statement' }),
    link: '/payment-overview',
    externalUrl: false,
    icon: '/images/navbar/contribution_confirmation.svg',
    displayForInsuranceTypes: [INSURANCE_TYPE_DENTOLO, INSURANCE_TYPE_VITOLO],
  },
];

export const useClaimsInfoLink = {
  path: '/user-claims-info',
  title: <FormattedMessage id="menu.header.item.reimbursement" />,
};

export const claimsReportLink = {
  path: '/user-claims-info',
  title: <FormattedMessage id="menu.header.item.claim_report" />,
};

export const dentistsMapLink = {
  path: '/dentists-map',
  title: <FormattedMessage id="menu.header.item.find_dentist" />,
};

export const useHealthPartnerLink = {
  path: '/health-partner-info',
  title: <FormattedMessage id="menu.header.item.partner" />,
};

export const onlineVetsLink = {
  path: '/online-vets',
  title: <FormattedMessage id="menu.header.item.find_vet" />,
};

export const referralLink = {
  path: '/referral',
  title: <FormattedMessage id="menu.header.item.referrals" />,
};

export const daDirektReferralLinkDental = {
  title: (
    <>
      <FormattedMessage id="menu.header.item.referrals" />
      <IconExternalLink />
    </>
  ),
  link: DA_DIREKT_REFERRAL_PAGE_LINK_NAV_DENTAL,
  externalUrl: true,
};

export const daDirektReferralLinkPet = {
  title: (
    <>
      <FormattedMessage id="menu.header.item.referrals" />
      <IconExternalLink />
    </>
  ),
  link: DA_DIREKT_REFERRAL_PAGE_LINK_NAV_PET,
  externalUrl: true,
};
